import { liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Caption } from '@telegram-apps/telegram-ui';
import { type FC, useMemo } from 'react';
import {
    FLOATING_TABBAR_HORIZONTAL_INSET,
    FLOATING_TABBAR_SATELLITE_SIZE,
    floatingTabbarActionColumnReservedWidth,
    floatingTabbarSatelliteBottomOffset,
} from '../../helpers/floatingTabbarLayout';
import { useCachedCategoriesWithFallback } from '../../hooks/caching/category';
import { CommonIcon } from '../common/CommonIcon';
import { BorderLinearProgress } from './BorderLinearProgress';

export const AchievementProgressFloatingBlock: FC = () => {
    const { categories } = useCachedCategoriesWithFallback();

    const { total, completed } = useMemo(() => ({
        total: categories.reduce((sum, c) => sum + (c.achievementProgressTotal || 0), 0),
        completed: categories.reduce((sum, c) => sum + (c.achievementProgressCompleted || 0), 0),
    }), [categories]);
    const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

    return (
        <Box
            data-testid="achievement-progress-floating-block"
            sx={{
                position: 'fixed',
                left: `${FLOATING_TABBAR_HORIZONTAL_INSET}px`,
                right: `calc(${FLOATING_TABBAR_HORIZONTAL_INSET}px + ${floatingTabbarActionColumnReservedWidth}px)`,
                bottom: floatingTabbarSatelliteBottomOffset,
                zIndex: 1300,
                pointerEvents: 'none',
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                gap="8px"
                sx={{
                    width: '100%',
                    height: FLOATING_TABBAR_SATELLITE_SIZE,
                    px: '10px',
                    boxSizing: 'border-box',
                    borderRadius: `${FLOATING_TABBAR_SATELLITE_SIZE / 2}px`,
                    ...liquidGlassSurfaceFillSx,
                }}
            >
                <CommonIcon icon="emoji_events" type="filled" size={14} color="var(--tgui--hint_color)" style={{ flexShrink: 0 }} />
                <BorderLinearProgress variant="determinate" value={percentage} sx={{ flex: 1, minWidth: 0, height: 5, borderRadius: 3 }} />
                <Caption style={{ flexShrink: 0, fontSize: '11px', fontWeight: '700', color: 'var(--tgui--button_color)' }}>
                    {percentage}%
                </Caption>
            </Stack>
        </Box>
    );
};
